import React from 'react';
import Grid from '@mui/material/Grid';
//import Typography from '@mui/material/Typography';
//import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
//import NotificationsIcon from '@mui/icons-material/Notifications';
import TopSalesBox from './TopSalesBox';
import Title from './Title';
import useStyles from './Styles';

interface TopStarsProps {
    stars:any,
    months: string[],
}

const TopStars:React.FC<TopStarsProps> = (props)=> {
	const classes = useStyles();
	return (
        <Box style={{marginBottom:"4em"}}>
            <Title text="獲得したフォロワー数"/>
            <Grid container spacing={2}>
                <Grid item xs={6} md={3}>
                    <TopSalesBox title="今月" date={props.months[0]} primary={props.stars.month0} primaryUnit="人"/>
                </Grid>
                <Grid item xs={6} md={3}>
                    <TopSalesBox title="先月" date={props.months[1]} primary={props.stars.month1} primaryUnit="人"/>
                </Grid>
                <Grid item xs={6} md={3}>
                    <TopSalesBox title="先々月" date={props.months[2]} primary={props.stars.month2} primaryUnit="人"/>
                </Grid>
                <Grid item xs={6} md={3}>
                    <TopSalesBox title="通算" primary={props.stars.all} primaryUnit="人"/>
                </Grid>
            </Grid>
        </Box>
    );
}

export default TopStars;
